import React from 'react';

const useFileState = (number_of_guarantors: number) => {
	const [fileOcr, setFileOcr] = React.useState<File | null>(null);
	const [fileGuarantors, setFileGuarantors] = React.useState<(File | null)[]>(
		new Array(number_of_guarantors).fill(null),
	);
	const [formValid, setFormValid] = React.useState(false);

	const handleFileChangeOcr = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.files) setFileOcr(event.target.files[0]);
	};

	const handleFileChangeGuarantor = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
		if (event.target.files)
			setFileGuarantors(
				fileGuarantors.map((fg, i) => (index === i ? (event.target.files?.[0] ?? null) : fg)),
			);
	};

	React.useEffect(() => {
		setFormValid(!!fileOcr && fileGuarantors.every((fg) => fg));
	}, [fileOcr, fileGuarantors]);

	return { fileOcr, fileGuarantors, formValid, handleFileChangeOcr, handleFileChangeGuarantor };
};

export default useFileState;
